import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { ImagesCarouselComponent } from '@connect-services/client/components/images-carousel/images-carousel.component';
import { NoDataToDisplayComponent } from '@connect-services/client/components/no-data-to-display/no-data-to-display.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ImagesCarouselComponent, MatDialogModule, NoDataToDisplayComponent, RessourcesModule],
    selector: 'app-image-modal',
    templateUrl: './image-modal.component.html',
})
export class ImageModalComponent {
    public data: {
        images: string[];
        title: string;
    } = inject(MAT_DIALOG_DATA);
}
